import { render, staticRenderFns } from "./TaskPresets.vue?vue&type=template&id=6bc8508a&"
import script from "./TaskPresets.vue?vue&type=script&lang=js&"
export * from "./TaskPresets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports